import { Tooltip } from "primereact/tooltip";
import { useEffect, useRef, useState } from "react";

export const EllipsisCell = ({ text }: { text: string }) => {
  const ref = useRef<HTMLDivElement>(null);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    if (ref.current) {
      setShowTooltip(ref.current.scrollWidth > ref.current.clientWidth);
    }
  }, [text]);

  return (
    <>
      {showTooltip && <Tooltip target=".ellipsis-cell" />}

      <div
        ref={ref}
        className="ellipsis-cell"
        style={{
          width: "250px",
          overflow: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
        }}
        data-pr-tooltip={showTooltip ? text : undefined}
        data-pr-position="top"
      >
        {text}
      </div>
    </>
  );
};